<!--
    Page: Renewal Renew Policy
    Author: Sunny 
	Date: 01-09-2020
-->

<div class="container-fluid mob-pad-l-r-0 tab-pad-l-r-0 parent-div">
    <div class="row mob-pad-l-r-0 tab-pad-l-r-0 ">
        <div class="col-lg-6 col-md-5 col-sm-5 d-none d-sm-block">
            <img class="download-img-width new-illustration" src="assets/images/new-renew/renew-illustration-abc.svg">
            <div class="renew-policy-bg">
                <div class="renew-your-policy-txt">Renew your Policy</div>
            </div>
        </div>
        <div class="col-lg-6 col-md-7 col-sm-7 col-xs-12 mob-pad-l-r-0 tab-pad-l-r-0 form-page renewal-login">
            <!-- <div class="d-none d-sm-block help-us-header-txt">Help us find your policy by <span class="any-two-red-clr">entering ANY 2</span> from the below</div> -->
            <div class="d-none d-sm-block help-us-header-txt">Help us find your policy</div>
            <div class="d-lg-none d-md-none d-sm-none col-xs-12 mob-white-bg">
                <div class="mob-renew-policy-txt">Renew your Policy</div>
                <div class="help-us-header-txt">Help us find your policy</div>
                <!-- <div class="help-us-header-txt">Help us find your policy by <span class="any-two-red-clr">entering ANY 2</span> from the below</div> -->
            </div>

            <form form [formGroup]="form" 
                (ngSubmit)="this.appservice.submitEvent('group-renewal-login','click','login-click') ;  onSubmit(auth,form)">
                <div>
                    <div class="row text-right lbl-pad-btm justify-content-end  mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 pad-l-r-0">
                            <label class="lbl-txt">Your COI Number <span class="any-two-red-clr">*</span></label>
                        </div>
                        <div class="col-lg-9 col-md-9 pad-l-r-0 pull-right">
                            <input type="text" class="form-control textbox-style phone-group"
                                style="text-transform: uppercase;" [(ngModel)]="auth.policynumber"
                                id="policynum" policyNumberOnly formControlName="policyNo" 
                                placeholder="G0-00-0000000-00">
                        </div>
                    </div>

                    <div class="row text-right lbl-pad-btm justify-content-end mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 pad-l-r-0">
                            <label class="lbl-txt">Proposer’s Date of Birth</label>
                        </div>
                        <div class="col-lg-9 col-md-9 pad-l-r-0 pull-right">
                            <input class="form-control textbox-style phone-group" type="tel"
                                placeholder="DD/MM/YYYY" formControlName="dob" [(ngModel)]="auth.dob" dateOfBirthOnly
                                maxlength="10"
                                (ngModelChange)="changeField()"
                                [attr.disabled]="((auth.policynumber != '' && auth.txtMobileNumber !='' ) ||(auth.txtMobileNumber !='')) ? true : null">
                        </div>
                    </div>

                    <div class="row text-right justify-content-end mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right justify-content-end">
                            <div class="col-lg-12 col-md-12 pad-l-r-0">
                                <label class="lbl-txt"><span class="any-two-red-clr">OR</span></label>
                            </div>
                        </div>
                    </div>

                    <div class="row text-right lbl-pad-btm justify-content-end mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 pad-l-r-0">
                            <label class="lbl-txt">Proposer’s Mobile Number</label>
                        </div>
                        <div class="col-lg-9 col-md-9 pad-l-r-0 pull-right">
                            <input class="form-control textbox-style phone-group"  type="text"
                                placeholder="Mobile Number" formControlName="txtMobileNumber"
                                [(ngModel)]="auth.txtMobileNumber" id="txtMobileNumber" minlength="10" appNumberOnly
                                maxlength="10"
                                [disabled]="(auth.policynumber != '' && auth.dob != '') || auth.dob != ''">
                        </div>
                    </div>

                    <div class="row text-right lbl-pad-btm justify-content-end">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right proceed-btn-pad-btm">
                            <a href="javascript:void(0);" >
                                <button type="submit" [disabled]="loading" class="btn proceed-btn">ABHI Karo</button>
                            </a>
                        </div>
                    </div>

                </div>
            </form>

        </div>
    </div>
</div>

<app-alert-swipe></app-alert-swipe>